import { api } from './api';
import type { Audit, AuditConfig, AuditType, TriageLog, WebsiteAuditSummary } from '@traaker/shared';

export const auditsApi = {
  list: (type?: AuditType, brandId?: string) => {
    const params = new URLSearchParams();
    if (type) params.set('type', type);
    if (brandId) params.set('brandId', brandId);
    const qs = params.toString();
    return api.get<Audit[]>(`/audits${qs ? `?${qs}` : ''}`);
  },

  getById: (auditId: string) =>
    api.get<Audit>(`/audits/${auditId}`),

  getResults: (auditId: string, agent?: string) => {
    const params = agent ? `?agent=${agent}` : '';
    return api.get<any[]>(`/audits/${auditId}/results${params}`);
  },

  getSummary: (auditId: string) =>
    api.get<WebsiteAuditSummary>(`/audits/${auditId}/summary`),

  getTriage: (auditId: string) =>
    api.get<TriageLog | null>(`/audits/${auditId}/triage`),

  getPageDetail: (auditId: string, agent: string, urlHash: string) =>
    api.get<any>(`/audits/${auditId}/results/${agent}/${urlHash}`),

  create: (type: AuditType, config: AuditConfig, brandId?: string) =>
    api.post<Audit>('/audits', { type, config, brandId }),
};
